export enum SOURCES {
	TWOGIS = '2GIS',
	FRIDGE = 'FRIDGE',
	QR = 'QR',
	STAND_QR = 'STANDQR',
	TABLET = 'TABLET',
	TABLET_QR = 'TABLETQR'
}
